import { io } from "socket.io-client";

export const socket = io(import.meta.env.VITE_SOCKET_URL, {
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: 8, // 8 attempts to reconnect
  reconnectionDelay: 5000, // 5 seconds between attempts
  reconnectionDelayMax: 5000, // 5 seconds maximum delay
});
